import aa from 'search-insights';
import Cookies from 'js-cookie';

// This should not be changing between renders, so there's no need
// to recreate the value every thing the component renders
export const ALGOLIA_INDEX_NAME = process?.env?.ALGOLIA_INDEX_JOBS;

// check for a cookie set from a job search/listing page
// this cookie should follow this format in its shape:
// <queryIdHash>--<userSelectedJobSlug>
export const retrieveAlgoliaTrackingCookieData = () => {
    const algoliaTrackingCookieData = Cookies.get(
        'fgb_algolia_search_query_id'
    );

    // parse out the cookie to obtain the two values in a tuple
    const [algoliaQueryID, placedHash] = algoliaTrackingCookieData
        ? algoliaTrackingCookieData.split('--')
        : [null, null];

    return {
        algoliaQueryID,
        placedHash,
    };
};

export const handleFiringAlgoliaEmitterOnSearchResult = ({
    queryID,
    indexName,
    positionInListing,
    hash,
}) => {
    // user clicked on a listing, so we fire off the event and include the position of where
    // that job listing was in the overall result list
    aa('clickedObjectIDsAfterSearch', {
        eventName: 'Job Listing Clicked On From List',
        objectIDs: [hash],
        positions: [positionInListing],
        queryID,
        index: indexName,
    });

    // we also set a cookie, so that if they click the apply button on the single
    // job page after searching for this result, we mark that as a conversion.
    Cookies.set('fgb_algolia_search_query_id', `${queryID}--${hash}`, {
        expires: 1,
    });
};

// handle firing off the algolia jawn if qualifications are met
export const handleFiringNonSearchAlgoliaEmitter = (
    hash = '',
    pos = '',
    altLabel
) => {
    // not on the client? bail.
    if (typeof window === 'undefined') return false;

    const { algoliaQueryID, placedHash } = retrieveAlgoliaTrackingCookieData();

    // If the conversion has nothing to do with a search, we still want to track it,
    // however, we will have to use a different method that does not require the cookie
    // query id
    if (
        !algoliaQueryID || // there is no existing query id from the cookie
        !ALGOLIA_INDEX_NAME || // if there is no algolia index name present
        placedHash !== hash // or the hash stored in the cookie does not match the current slug
    ) {
        aa('convertedObjectIDs', {
            index: ALGOLIA_INDEX_NAME,
            eventName: `Nonquery applied to job via ${pos} button on sjp`,
            objectIDs: [hash],
        });

        return true;
    }

    // We've made it this far. Let's fire off to Algolia.
    // The eventName contains the position of the button that
    // the user used to trigger the event
    aa('convertedObjectIDsAfterSearch', {
        eventName: altLabel ?? `Query  applied to job via ${pos} button on sjp`,
        objectIDs: [hash],
        queryID: algoliaQueryID,
        index: ALGOLIA_INDEX_NAME,
    });

    return true; // return true because we successfully completed
};
